module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/aq368-e65e56f9a404a63c66d7a4b1a3a3c874.jpg";